import React from 'react';

// ─── BRAND COLOURS ───
//
// One source of truth for the sleep colour. Every surface that paints a
// sleep affordance (Recent Activities, Insights "Sleep quality" row,
// dashboard Health Tips) imports this constant so the icon tone stays
// identical wherever the user looks. Was previously inconsistent —
// `#0084FF` in some widgets, `#6366f1` in others, `#7B9FE0` in the
// mobile dashboard — which made the same activity look like three
// different things on the same screen.
export const SLEEP_COLOR = '#7B9FE0';

// ─── ACTIVITY ICONS (shared across Insights and Dashboard) ───

export function WalkIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 47 43" fill="none">
      <path
        d="M13.7083 37.625L19.5833 30.4583M31.3333 37.625L27.4167 30.4583L21.5417 25.0833L23.5 14.3333M23.5 14.3333L15.6667 16.125L11.75 21.5M23.5 14.3333L29.375 19.7083L35.25 21.5M23.5 7.16667C23.5 7.64185 23.7063 8.09756 24.0736 8.43357C24.4408 8.76957 24.939 8.95833 25.4583 8.95833C25.9777 8.95833 26.4758 8.76957 26.8431 8.43357C27.2103 8.09756 27.4167 7.64185 27.4167 7.16667C27.4167 6.69149 27.2103 6.23577 26.8431 5.89977C26.4758 5.56376 25.9777 5.375 25.4583 5.375C24.939 5.375 24.4408 5.56376 24.0736 5.89977C23.7063 6.23577 23.5 6.69149 23.5 7.16667Z"
        stroke={color}
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SleepIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 33 26" fill="none">
      <path
        d="M28.7124 11.12C27.9884 10.7933 27.2061 10.6249 26.4154 10.6256H5.74248C4.95182 10.6248 4.16962 10.7929 3.44549 11.1192C2.42204 11.5793 1.55114 12.336 0.93925 13.2966C0.327359 14.2573 0.000977978 15.3804 0 16.5287V24.7931C0 25.1062 0.121002 25.4065 0.336387 25.6279C0.551772 25.8493 0.843896 25.9737 1.1485 25.9737C1.4531 25.9737 1.74522 25.8493 1.96061 25.6279C2.17599 25.4065 2.29699 25.1062 2.29699 24.7931V24.2028C2.29885 24.0468 2.35995 23.8977 2.46724 23.7875C2.57454 23.6772 2.71952 23.6144 2.87124 23.6124H29.2867C29.4384 23.6144 29.5834 23.6772 29.6907 23.7875C29.7979 23.8977 29.859 24.0468 29.8609 24.2028V24.7931C29.8609 25.1062 29.9819 25.4065 30.1973 25.6279C30.4127 25.8493 30.7048 25.9737 31.0094 25.9737C31.314 25.9737 31.6061 25.8493 31.8215 25.6279C32.0369 25.4065 32.1579 25.1062 32.1579 24.7931V16.5287C32.1568 15.3806 31.8303 14.2576 31.2184 13.2971C30.6066 12.3365 29.7357 11.58 28.7124 11.12ZM24.6927 0H7.46523C6.39913 0 5.37669 0.435353 4.62284 1.21029C3.869 1.98522 3.44549 3.03626 3.44549 4.13218V9.44498C3.44552 9.49071 3.45589 9.53582 3.47579 9.57673C3.49568 9.61764 3.52455 9.65324 3.56012 9.68072C3.59569 9.7082 3.63699 9.7268 3.68075 9.73506C3.72451 9.74332 3.76954 9.74102 3.81229 9.72832C4.43927 9.53982 5.08924 9.4444 5.74248 9.44498H6.04612C6.11699 9.44544 6.18552 9.41894 6.23852 9.37058C6.29153 9.32222 6.32527 9.25542 6.33324 9.18303C6.39588 8.60614 6.66305 8.07318 7.08371 7.68594C7.50437 7.29871 8.04905 7.08432 8.61372 7.08373H12.6335C13.1985 7.08378 13.7437 7.29792 14.1648 7.68521C14.5859 8.0725 14.8534 8.60576 14.9161 9.18303C14.9241 9.25542 14.9578 9.32222 15.0108 9.37058C15.0638 9.41894 15.1323 9.44544 15.2032 9.44498H16.959C17.0299 9.44544 17.0984 9.41894 17.1514 9.37058C17.2044 9.32222 17.2381 9.25542 17.2461 9.18303C17.3087 8.60652 17.5756 8.07387 17.9958 7.68668C18.416 7.29949 18.9601 7.08486 19.5244 7.08373H23.5442C24.1092 7.08378 24.6544 7.29792 25.0755 7.68521C25.4967 8.0725 25.7641 8.60576 25.8268 9.18303C25.8348 9.25542 25.8682 9.32222 25.9212 9.37058C25.9742 9.41894 26.0428 9.44544 26.1136 9.44498H27.2575C27.9001 9.44493 28.536 9.53938 29.142 9.72368C29.1837 9.73614 29.2279 9.73827 29.2703 9.72993C29.3127 9.72159 29.3523 9.70302 29.3851 9.67588C29.4179 9.64874 29.4427 9.614 29.4569 9.57519C29.4711 9.53638 29.4741 9.49469 29.4656 9.44418V4.13138C29.4656 3.03546 29.0421 1.98442 28.2883 1.20948C27.5344 0.434552 26.512 0 25.4459 0H24.6927Z"
        fill={color}
      />
    </svg>
  );
}

export function LotusIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 33 33" fill="none">
      <path d="M16.5 28.46C16.32 28.46 16.16 28.4 16.03 28.28C14.16 26.61 12.67 24.57 11.65 22.29C10.63 20.01 10.1 17.54 10.1 15.04C10.1 12.54 10.63 10.07 11.65 7.79C12.67 5.51 14.16 3.47 16.03 1.8C16.16 1.69 16.32 1.62 16.5 1.62C16.67 1.62 16.84 1.69 16.97 1.8C18.84 3.47 20.33 5.51 21.35 7.79C22.37 10.07 22.9 12.54 22.9 15.04C22.9 17.54 22.37 20.01 21.35 22.29C20.33 24.57 18.84 26.61 16.97 28.28C16.84 28.4 16.67 28.46 16.5 28.46Z" fill={color} />
      <path d="M15.79 24.28C15.79 20.47 14.39 16.79 11.86 13.93C9.34 11.08 5.86 9.24 2.07 8.77C1.9 8.75 1.72 8.79 1.58 8.89C1.43 8.99 1.33 9.14 1.29 9.32C0.75 11.58 0.72 13.93 1.2 16.2C1.69 18.47 2.67 20.61 4.09 22.45C5.51 24.29 7.31 25.79 9.39 26.85C11.46 27.9 13.74 28.47 16.06 28.53L16.5 28.54C15.99 27.18 15.75 25.73 15.79 24.28Z" fill={color} />
      <path d="M17.21 24.28C17.21 20.47 18.61 16.79 21.13 13.93C23.66 11.08 27.14 9.24 30.93 8.77C31.1 8.75 31.28 8.79 31.42 8.89C31.57 8.99 31.67 9.14 31.71 9.32C32.25 11.58 32.28 13.93 31.8 16.2C31.31 18.47 30.33 20.61 28.91 22.45C27.49 24.29 25.68 25.79 23.61 26.85C21.54 27.9 19.26 28.47 16.94 28.53L16.5 28.54C17.01 27.18 17.25 25.73 17.21 24.28Z" fill={color} />
      <path d="M16.5 28.54C16.32 28.54 16.16 28.48 16.02 28.36C14.95 27.4 14.09 26.22 13.5 24.91C12.91 23.59 12.6 22.17 12.6 20.73C12.6 19.28 12.91 17.86 13.5 16.54C14.09 15.23 14.95 14.05 16.02 13.09C16.16 12.97 16.32 12.91 16.5 12.91C16.67 12.91 16.84 12.97 16.97 13.09C18.05 14.05 18.91 15.23 19.5 16.54C20.09 17.86 20.39 19.28 20.39 20.73C20.39 22.17 20.09 23.59 19.5 24.91C18.91 26.22 18.05 27.4 16.97 28.36C16.84 28.48 16.67 28.54 16.5 28.54Z" fill={color} />
      <path d="M9.26 31.38C8.91 31.38 8.56 31.36 8.2 31.33C6.61 31.18 5.07 30.69 3.69 29.9C2.3 29.12 1.09 28.05 0.14 26.76C0.04 26.62 -0.01 26.45 0 26.27C0.02 26.1 0.1 25.93 0.23 25.82C1.4 24.73 2.79 23.9 4.3 23.39C5.81 22.88 7.42 22.69 9.01 22.84C10.6 22.99 12.14 23.48 13.53 24.26C14.92 25.05 16.13 26.12 17.07 27.41C17.18 27.55 17.22 27.72 17.21 27.9C17.19 28.07 17.11 28.24 16.98 28.35C14.88 30.3 12.12 31.38 9.26 31.38Z" fill={color} />
      <path d="M16.02 28.35C15.89 28.24 15.81 28.07 15.79 27.9C15.78 27.72 15.82 27.55 15.93 27.41C16.87 26.12 18.08 25.05 19.47 24.26C20.86 23.48 22.4 22.99 23.99 22.84C25.58 22.69 27.19 22.88 28.7 23.39C30.21 23.9 31.6 24.73 32.77 25.82C32.9 25.93 32.98 26.1 33 26.27C33.01 26.45 32.96 26.62 32.86 26.76C31.91 28.05 30.7 29.12 29.31 29.9C27.93 30.69 26.39 31.18 24.8 31.33C24.44 31.36 24.09 31.38 23.74 31.38C20.88 31.38 18.12 30.3 16.02 28.35Z" fill={color} />
    </svg>
  );
}

/**
 * Returns the appropriate icon component for an activity based on its type and category.
 * Maps activity/exercise/walk to the walking person icon (matching Insights Quick Actions).
 */
export function getActivityIcon(activity) {
  const normalized = `${activity.type || ''} ${activity.category || ''}`.toLowerCase();


  // Walking-like activities -> walking person icon
  if (
    normalized.includes('activity') ||
    normalized.includes('walk') ||
    normalized.includes('walking')
  ) {
    return { Icon: WalkIcon, color: '#FFCC00' };
  }

  // Sports / exercise -> sports category icon
  if (
    normalized.includes('exercise') ||
    normalized.includes('sport') ||
    activity.category === 'sports'
  ) {
    return {
      Icon: (props) => <CategoryIcon id="sports" {...props} />,
      color: '#FF6B6B'
    };
  }
  
  // Sleep -> Bed icon
  if (normalized.includes('sleep') || activity.category === 'sleep') {
    return { Icon: SleepIcon, color: SLEEP_COLOR };
  }
  
  // Meditation/Yoga -> Lotus icon
  if (
    normalized.includes('meditation') ||
    normalized.includes('mindful') ||
    normalized.includes('yoga')
  ) {
    return { Icon: LotusIcon, color: '#7700FF' };
  }
  
  // Default: use category icon
  const categoryInfo = getCategoryInfo(activity.category);
  return { 
    Icon: (props) => <CategoryIcon id={categoryInfo.id} {...props} />, 
    color: categoryInfo.color 
  };
}

export const ACTIVITY_CATEGORIES = [
  { id: 'public_transportation', name: 'Public Transport', color: '#7B9FE0' },
  { id: 'communication', name: 'Communication', color: '#5CB89A' },
  { id: 'drive', name: 'Drive', color: '#A0ABA8' },
  { id: 'eat_drink', name: 'Eat/Drink', color: '#E3C937' },
  { id: 'manual_work', name: 'Manual Work', color: '#FF8A5C' },
  { id: 'mental_activity', name: 'Mental Activity', color: '#8B7CF6' },
  { id: 'pc', name: 'PC', color: '#4C8BF5' },
  { id: 'personal_hygiene', name: 'Personal Hygiene', color: '#90E2DA' },
  { id: 'phone_call', name: 'Phone Call', color: '#43B581' },
  { id: 'rest', name: 'Rest / Relax', color: '#B8A9E0' },
  { id: 'sleep', name: 'Sleep', color: '#7B9FE0' },
  { id: 'tv', name: 'TV', color: '#F2994A' },
  { id: 'walking', name: 'Walking', color: '#FFCC00' },
  { id: 'sports', name: 'Sports', color: '#FF6B6B' },
  { id: 'other', name: 'Other Activities', color: '#A0ABA8' },
];

export function CategoryIcon({ id, size = 22, color = 'currentColor' }) {
  const s = { width: size, height: size };

  switch (id) {
    case 'eat_drink':
      // Filled fork (left) + knife (right). Solid silhouette so it
      // matches the visual weight of the Health Tips icons.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M8.1 2v6.5H6.9V2H5.4v6.5H4.2V2H2.7v8a2.5 2.5 0 0 0 2 2.45V22h2v-9.55a2.5 2.5 0 0 0 2-2.45V2H8.1zM17 2c-1.93 0-3.5 2.91-3.5 6.5 0 2.39.7 4.47 1.75 5.58V22h3.5V2H17z" />
        </svg>
      );

    case 'sleep':
      // Same filled bed used in Health Tips, Quick Actions, Recent
      // Activities — single source of truth so the icon never drifts.
      return <SleepIcon size={size} color={color} />;

    case 'rest':
  // Filled cafe / coffee cup icon — matches mobile's "cafe" feeling better.
  return (
    <svg {...s} viewBox="0 0 24 24" fill={color}>
      <path d="M5 5a1 1 0 0 0-1 1v4.5A5.5 5.5 0 0 0 9.5 16H13a5 5 0 0 0 4.9-4H19a3 3 0 1 0 0-6h-1V5H5zm11 3h3a1 1 0 1 1 0 2h-2.8c-.03-.7-.1-1.37-.2-2zM6 7h8v3.5A3.5 3.5 0 0 1 10.5 14h-1A3.5 3.5 0 0 1 6 10.5V7zm2 11a1 1 0 1 0 0 2h8a1 1 0 1 0 0-2H8z" />
    </svg>
  );

    case 'personal_hygiene':
      // Filled water drop.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M12 2.5c-.4 0-.78.18-1.04.49C8.7 5.62 5 10.4 5 14a7 7 0 0 0 14 0c0-3.6-3.7-8.38-5.96-11.01A1.36 1.36 0 0 0 12 2.5zm0 16a4.5 4.5 0 0 1-4.5-4.5 1 1 0 0 1 2 0A2.5 2.5 0 0 0 12 16.5a1 1 0 0 1 0 2z" />
        </svg>
      );

    case 'public_transportation':
      // Filled bus.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M18 3H6a3 3 0 0 0-3 3v11a2.5 2.5 0 0 0 1.5 2.29V21a1 1 0 0 0 2 0v-1h11v1a1 1 0 0 0 2 0v-1.71A2.5 2.5 0 0 0 21 17V6a3 3 0 0 0-3-3zM5 6a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v4H5V6zm2 11a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 7 17zm10 0a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 17 17zm2-5H5v-1h14v1z" />
        </svg>
      );

    case 'drive':
      // Filled car.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M19.4 9.5l-1.45-3.6A3 3 0 0 0 15.16 4H8.84a3 3 0 0 0-2.79 1.9L4.6 9.5A3 3 0 0 0 2.5 12.4V18a1.5 1.5 0 0 0 1.5 1.5h.5a1.5 1.5 0 0 0 1.5-1.5v-1h12v1A1.5 1.5 0 0 0 19.5 19.5h.5a1.5 1.5 0 0 0 1.5-1.5v-5.6a3 3 0 0 0-2.1-2.9zM7.91 6.65A1 1 0 0 1 8.84 6h6.32a1 1 0 0 1 .93.65L17.34 10H6.66l1.25-3.35zM6.5 15a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 6.5 15zm11 0a1.25 1.25 0 1 1 1.25-1.25A1.25 1.25 0 0 1 17.5 15z" />
        </svg>
      );

    case 'manual_work':
      // Filled hammer.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M20.6 8.95L15.05 3.4a1.5 1.5 0 0 0-2.12 0L11.5 4.83l-1.42-1.42a1 1 0 0 0-1.41 1.42l1.42 1.41-7.78 7.78a2.5 2.5 0 0 0 0 3.54l1.06 1.06a2.5 2.5 0 0 0 3.54 0l7.78-7.78 1.41 1.42a1 1 0 0 0 1.42-1.42l-1.42-1.41 1.43-1.43a1.5 1.5 0 0 0 0-2.12z" />
        </svg>
      );

    case 'exercise':
      // Filled flame.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M16.97 11.5c-.79-2.04-1.97-3.05-1.97-4.97 0-1.21.4-2.32 1.03-3.13a.5.5 0 0 0-.65-.74C13.13 3.93 11.5 6.45 11.5 9c0 1.5-.5 2.25-1.25 3-.94.94-1.75 2-1.75 4.5a5.5 5.5 0 0 0 11 0c0-2-1.04-3.96-2.53-5zM12 19a3 3 0 0 1-3-3c0-1.5.5-2 1.25-2.75.5-.5.96-1 1.25-1.75.4 1.5 1.5 2.5 1.5 4a2 2 0 0 1-1 2z" />
        </svg>
      );

    case 'communication':
      // Filled chat bubble.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M12 2C6.5 2 2 6.04 2 11c0 1.74.55 3.36 1.5 4.74v3.51a1 1 0 0 0 1.5.87L7.83 18.5c1.27.43 2.66.66 4.17.66 5.5 0 10-4.04 10-9s-4.5-8.16-10-8.16z" />
        </svg>
      );
          case 'mental_activity':
      // Filled brain-like / focus icon.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M9 3.5a3.5 3.5 0 0 0-3.43 4.2A3.98 3.98 0 0 0 4 11a4 4 0 0 0 3 3.87V18a3 3 0 0 0 3 3h1v-7H9.5a1 1 0 1 1 0-2H11V9H9.5a1 1 0 1 1 0-2H11V3.5H9zm4 0V7h1.5a1 1 0 1 1 0 2H13v3h1.5a1 1 0 1 1 0 2H13v7h1a3 3 0 0 0 3-3v-3.13A4 4 0 0 0 20 11a3.98 3.98 0 0 0-1.57-3.3A3.5 3.5 0 0 0 15 3.5h-2z" />
        </svg>
      );

    case 'pc':
      // Filled desktop monitor.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M5 4a3 3 0 0 0-3 3v7a3 3 0 0 0 3 3h5v2H7.5a1 1 0 0 0 0 2h9a1 1 0 1 0 0-2H14v-2h5a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3H5zm0 2h14a1 1 0 0 1 1 1v7H4V7a1 1 0 0 1 1-1z" />
        </svg>
      );

    case 'phone_call':
      // Filled phone handset.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M6.54 3.5A1.5 1.5 0 0 0 5.1 4.6l-1 4.35a2 2 0 0 0 .57 1.88l2.34 2.21a16.48 16.48 0 0 0 3.95 3.95l2.21 2.34a2 2 0 0 0 1.88.57l4.35-1A1.5 1.5 0 0 0 20.5 17.46v-2.69a1.5 1.5 0 0 0-1.24-1.48l-3.18-.53a1.5 1.5 0 0 0-1.37.45l-1.05 1.05a12.45 12.45 0 0 1-3.92-3.92l1.05-1.05a1.5 1.5 0 0 0 .45-1.37l-.53-3.18A1.5 1.5 0 0 0 9.23 3.5H6.54z" />
        </svg>
      );

    case 'tv':
      // Filled TV screen.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M9.7 3.3a1 1 0 0 0-1.4 1.4L10.6 7H6a3 3 0 0 0-3 3v6a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a3 3 0 0 0-3-3h-4.6l2.3-2.3a1 1 0 1 0-1.4-1.4L12 6.59 9.7 3.3zM6 9h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1z" />
        </svg>
      );

    case 'walking':
      return <WalkIcon size={size} color={color} />;

    case 'sports':
      // Filled dumbbell.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <path d="M3 9h2v6H3v-2H1v-2h2V9zm4-2h2v10H7V7zm8 0h2v10h-2V7zm4 2h2v2h2v2h-2v2h-2V9zm-9 3a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2h1v2h-1a2 2 0 0 1-2 2h0a2 2 0 0 1-2-2H9v-2h1z" />
        </svg>
      );
    case 'other':
    default:
      // Three filled dots — generic catch-all.
      return (
        <svg {...s} viewBox="0 0 24 24" fill={color}>
          <circle cx="5" cy="12" r="2" />
          <circle cx="12" cy="12" r="2" />
          <circle cx="19" cy="12" r="2" />
        </svg>
      );
  }
}

export function getCategoryInfo(catId) {
  const aliases = {
    exercise: 'sports',
    sex: 'other',
  };

  const normalizedId = aliases[catId] || catId;

  return (
    ACTIVITY_CATEGORIES.find((category) => category.id === normalizedId) ||
    ACTIVITY_CATEGORIES.find((category) => category.id === 'other')
  );
}

export function formatDuration(min) {
  if (min >= 60) {
    const h = Math.floor(min / 60);
    const m = min % 60;
    return m > 0 ? `${h}h ${m}m` : `${h}h`;
  }

  return `${min} min`;
}

export function formatDateLabel(dateStr) {
  const today = new Date().toISOString().split('T')[0];
  const yesterday = new Date(Date.now() - 86400000).toISOString().split('T')[0];
  if (dateStr === today) return 'Today';
  if (dateStr === yesterday) return 'Yesterday';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatActivityTime(time) {
  if (!time) return '';
  const [hours, minutes] = time.split(':');
  if (hours == null || minutes == null) return time;

  const date = new Date();
  date.setHours(Number(hours), Number(minutes), 0, 0);
  return date.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
}

// ─── SLEEP HEATMAP ───
//
// The heatmap shows the last 21 days of sleep, computed from activities the
// user logged with `category: 'sleep'`. Same palette as Graphs sleep heatmap,
// rendered in a 3-row × 7-column grid (most-recent day = bottom-right).
//
// Palette indices, mapped from total minutes slept that day:
//   0 → inactive (no sleep logged)            → '#E1E1E1'
//   1 → < 3 h                                  → '#B0AAFF'
//   2 → 3–5 h                                  → '#9188FF'
//   3 → 5–7 h                                  → '#6255FF'
//   4 → 7 h+                                   → '#2E1DFF'

export const SLEEP_HEATMAP_PALETTE = ['var(--sleep-heatmap-inactive, #E1E1E1)', '#B0AAFF', '#9188FF', '#6255FF', '#2E1DFF'];
export const SLEEP_HEATMAP_ROWS = 3;
export const SLEEP_HEATMAP_COLS = 7;
const SLEEP_HEATMAP_DAYS = SLEEP_HEATMAP_ROWS * SLEEP_HEATMAP_COLS; // 21

function localDateKey(d) {
  // YYYY-MM-DD in the user's local timezone (NOT UTC, which would shift
  // late-night sleep into the wrong calendar day).
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

function minutesToPaletteIndex(min) {
  if (!min || min <= 0) return 0;
  if (min < 180) return 1;       // <  3h
  if (min < 300) return 2;       // 3–5h
  if (min < 420) return 3;       // 5–7h
  return 4;                       // 7h+
}

/**
 * Sums sleep durations per day for the last 21 days and returns a 3×7 grid
 * of palette indices ready to render. The most recent day is at the
 * bottom-right (row 2, col 6); 21 days ago is at the top-left.
 *
 * Activities matched: anything where `category === 'sleep'`. We sum the
 * `durationMin` of every matching record on the same date, so logging two
 * naps in one day correctly produces a single "well-rested" cell.
 */
export function computeSleepHeatmapCells(activities) {
  // Sum minutes per local-date key.
  const totals = {};
  if (Array.isArray(activities)) {
    for (const a of activities) {
      if (!a || a.category !== 'sleep') continue;
      const key = a.date; // already stored as YYYY-MM-DD by Activities.js
      const mins = Number(a.durationMin) || 0;
      if (!key || mins <= 0) continue;
      totals[key] = (totals[key] || 0) + mins;
    }
  }

  // Build the last 21 day-keys, oldest → newest.
  const today = new Date();
  const sequence = [];
  for (let i = SLEEP_HEATMAP_DAYS - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(d.getDate() - i);
    sequence.push(localDateKey(d));
  }

  // Reshape into 3 rows × 7 cols, oldest top-left → newest bottom-right.
  const grid = [];
  for (let r = 0; r < SLEEP_HEATMAP_ROWS; r++) {
    const row = [];
    for (let c = 0; c < SLEEP_HEATMAP_COLS; c++) {
      const dayKey = sequence[r * SLEEP_HEATMAP_COLS + c];
      row.push(minutesToPaletteIndex(totals[dayKey]));
    }
    grid.push(row);
  }
  return grid;
}

/**
 * Returns true if the activity list contains at least one sleep entry with
 * a positive duration. Used to decide whether the heatmap should render
 * real data or fall back to a deterministic demo grid.
 *
 * Why this exists: computeSleepHeatmapCells always returns a 3x7 grid full
 * of zeros when the user has no sleep data, which is "truthy" in JS — so a
 * naive `cellsFromData || fallback` check would never trigger the fallback.
 * This helper makes the empty/non-empty decision explicit at the call site.
 */
export function hasAnySleepData(activities) {
  if (!Array.isArray(activities)) return false;
  return activities.some(
    (a) => a && a.category === 'sleep' && Number(a.durationMin) > 0
  );
}

/**
 * Deterministic placeholder grid shown when the user has zero sleep data.
 * Same shape as computeSleepHeatmapCells output (3 rows x 7 cols), same
 * palette indices (0..4). Mirrors the original Graphs hardcoded grid so
 * the visual stays familiar across both pages and across reloads.
 */
export const SLEEP_HEATMAP_FALLBACK_CELLS = [
  [0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0],
  [0, 0, 0, 0, 0, 0, 0],
];